module.exports = __webpack_public_path__ + "static/media/img23.9643d30f.JPG";